import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { darkPurple } from 'utils/color-styles';

export const BackButton = ({
  color,
  size,
  ...rest
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { color?: string; size?: number }) => (
  <button
    type="button"
    style={{
      borderRadius: '50%',
      width: size || 33,
      height: size || 33,
      border: `1px ${color || darkPurple} solid`,
      marginRight: 8,
      cursor: 'pointer',
    }}
    {...rest}
  >
    <ArrowBackIcon style={{ fontSize: 16 }} />
  </button>
);
